import React from 'react';
import { Button, Flex } from '@chakra-ui/react';
import { CarouselRecedeIcon } from '../../common/components/icons/carousel_recede';
import { CarouselAdvanceIcon } from '../../common/components/icons/carousel_advance';

const CarouselControl = ({
	imageResource,
	action,
	isDisabled,
}: {
	imageResource: React.ReactNode;
	action: () => void;
	isDisabled: boolean;
}) => (
	<Button
		variant="unstyled"
		borderRadius="full"
		minWidth="auto"
		height="auto"
		onClick={action}
		disabled={isDisabled}
	>
		{imageResource}
	</Button>
);

export const CarouselControls = ({
	onRecede,
	onAdvance,
	elements,
}: {
	onRecede: () => void;
	onAdvance: () => void;
	elements: { total: number; perPage: number; currentPage: number };
}) => (
	<Flex
		gridGap="8px"
		alignItems="center"
	>
		<CarouselControl
			imageResource={<CarouselRecedeIcon />}
			action={onRecede}
			isDisabled={elements.currentPage === 1}
		/>
		<CarouselControl
			imageResource={<CarouselAdvanceIcon />}
			action={onAdvance}
			isDisabled={elements.currentPage >= Math.ceil(elements.total / elements.perPage)}
		/>
	</Flex>
);
